import ConfigManager from "./ConfigManager";
import googletag from "./googletag";
import Logger from "./Logger";
import TargetingManager from "./TargetingManager";

class GoogletagManager {
  containerSlotMap: Object = {};

  getSlot(containerId: string) {
    return this.containerSlotMap[containerId]?.slot;
  }
  getAdUnitCodeForSlot(containerId: string) {
    return this.containerSlotMap[containerId]?.adUnitPath;
  }

  setGlobalTargeting() {
    const t = TargetingManager.getGlobalTargeting();
    Logger.log("Setting global targeting", t);
    Object.keys(t).forEach((k) => {
      Logger.log(`Global key ${k}:${t[k]}`);
      googletag().pubads().setTargeting(k, String(t[k]));
    });
  }

  setSlotTargeting() {
    Logger.log("setSlotTargeting called", this.containerSlotMap);
    Object.keys(this.containerSlotMap).forEach((slotName) => {
      const t = TargetingManager.getSlotTargeting(slotName);
      Logger.log("Setting slot targeting for ", slotName, t);
      if (t) {
        Object.keys(t).forEach((key) => {
          this.containerSlotMap[slotName].slot.setTargeting(
            key,
            String(t[key])
          );
        });
      }
    });
  }

  addSlot(adUnit: string, containerId: string) {
    ConfigManager.addAdUnitToContainerMapping(adUnit, containerId);

    Logger.log(`adding slot for ${adUnit} to container ${containerId}`);
    if (!ConfigManager.hasAdUnit(adUnit)) {
      throw new Error(`adUnit '${adUnit}' does not exist in the config.`);
    }

    const sizes = ConfigManager.getAdUnitSizes(adUnit);
    const adUnitPath = ConfigManager.getAdUnitPath(adUnit);
    if (this.containerSlotMap[containerId]) {
      Logger.log("Slot on this container already exists. Destroying.");
      googletag().destroySlots([this.containerSlotMap[containerId].slot]);
      delete this.containerSlotMap[containerId];
    }
    const slot = googletag()
      .defineSlot(adUnitPath, sizes, containerId)
      .setCollapseEmptyDiv(false, false)
      .addService(googletag().pubads());
    googletag().pubads().enableSingleRequest();
    googletag().enableServices();
    this.containerSlotMap[containerId] = { slot, adUnitPath };
    Logger.log("containerSlotMap", this.containerSlotMap);
    return slot;
  }
}

export default new GoogletagManager();
